/**
 * 路由守卫用到的纯判断：页面访问权限、页面标题、登录后回跳地址。
 * 路由表的 beforeLoad 和布局组件调用这些函数，便于单独测试。
 */
import type { ComponentType } from 'react'

// 路由元信息（挂在 TanStack Router 的 staticData 上），字段与旧版 router/modules/*.ts 的 meta 一致
export interface RouteMeta {
  title?: string
  icon?: ComponentType
  // 菜单排序；百位数决定所属分组，见 menu.ts
  order?: number
  permissions?: string[]
  roles?: string[]
  hideInMenu?: boolean
}

declare module '@tanstack/react-router' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface StaticDataRouteOption extends RouteMeta {}
}

export interface AccessChecker {
  hasPermission: (permission: string) => boolean
  hasAnyRole: (roles: string[]) => boolean
}

// 页面要求的角色满足其一、权限全部具备才可访问
export function canAccess(meta: RouteMeta | undefined, checker: AccessChecker): boolean {
  if (meta?.roles?.length && !checker.hasAnyRole(meta.roles)) return false
  if (meta?.permissions?.length && !meta.permissions.every((permission) => checker.hasPermission(permission))) {
    return false
  }
  return true
}

const APP_TITLE = 'AcquiLang AI 管理中台'

export function pageTitle(title: string | undefined): string {
  return title ? `${title} - ${APP_TITLE}` : APP_TITLE
}

export const HOME_PATH = '/dashboard'

// 登录后回跳地址只接受站内路径，避免 ?redirect= 跳到外站；回跳到登录页本身也没有意义
export function safeRedirect(redirect: string | undefined): string {
  if (redirect && redirect.startsWith('/') && !redirect.startsWith('//') && !/^\/login(?=[/?#]|$)/.test(redirect)) {
    return redirect
  }
  return HOME_PATH
}
